import type { Action, Store } from 'redux';

import type { ReduxInjections } from 'src/types';

export const createDependencyInjector =
  (deps: Partial<ReduxInjections>) =>
  (store: Store) =>
  (next: (action: Action) => void) =>
  (action: ((a: Partial<ReduxInjections> & Store) => void) | Action) =>
    // @ts-expect-error I don't think it's possible to narrow this type currently
    typeof action === 'function' ? action({ ...deps, ...store }) : next(action);
